module.exports = __webpack_public_path__ + "media/bootstrap-icons/egg-fill-3e5c78ba.svg";